import { configureStore } from '@reduxjs/toolkit';
import catalogReducer from './slices/catalogSlice';
import productReducer from './slices/productSlice'
import searchReducer from './slices/searchSlice';
import cartReducer from './slices/cartSlice';
import { saveCart } from '../services/cartService';

const store = configureStore({
  reducer: {
    catalog: catalogReducer,
    products: productReducer,
    search: searchReducer,
    cart: cartReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(),
});

let previousCartState = store.getState().cart.items;

store.subscribe(() => {
  const nextState = store.getState().cart;
  const nextCartState = nextState.items;

  if (!nextState.isHydrated) {
    previousCartState = nextCartState;
    return;
  }

  if (nextCartState !== previousCartState) {
    previousCartState = nextCartState;
    saveCart(nextCartState);
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
